import { Column, Table } from "@fronterahealth/frontera-ui-components";

import { PAGE_SIZE } from "@pages/VideoAnalytics/helpers";

interface RawDataTableWrapperProps<T> {
  data: T[];
  columns: Column<T>[];
  loading?: boolean;
  totalItemCount: number;
  defaultItemsPerPage: number;
  onPageChange: (current: number, itemsPerPage: number) => void;
  wrapperClassName?: string;
  currentPage?: number;
  /** When set, rows become clickable (Mosaic already renders them with a pointer cursor). */
  onRowClick?: (row: T) => void;
}

export const RawDataTableWrapper = <T,>({
  data,
  columns,
  loading,
  totalItemCount,
  defaultItemsPerPage = PAGE_SIZE,
  onPageChange,
  wrapperClassName,
  currentPage = 1,
  onRowClick,
}: RawDataTableWrapperProps<T>) => {
  return (
    <div className={`flow-root bg-white w-full overflow-hidden rounded-lg ${wrapperClassName ?? ""}`}>
      <Table
        data={data}
        columns={columns}
        loading={loading}
        showPagination
        totalItemCount={totalItemCount}
        defaultItemsPerPage={defaultItemsPerPage}
        onPageChange={onPageChange}
        onRowClick={onRowClick}
        cellClassName="py-1.5 px-2 max-w-0 overflow-hidden"
        headingClassName="pl-2! pr-2"
        currentPageNo={currentPage}
      />
    </div>
  );
};
